module.exports = __webpack_public_path__ + "10681f8c681bfef825d5beb2a4978891.png";